module.exports = __webpack_public_path__ + "img/Frame-16.48625921.svg";